module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-switch"
  }, [_c('div', {
    staticClass: "switch",
    on: {
      "click": _vm.toggleSwitch
    }
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "id": _vm.idEl,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.active,
      "value": _vm.active
    }
  }), _c('label', {
    staticClass: "switch-paddle",
    attrs: {
      "for": _vm.idEl
    }
  }, [_c('span', {
    class: {
      'switch-active': _vm.value, 'switch-inactive': !_vm.value
    },
    domProps: {
      "innerHTML": _vm._s(Boolean(_vm.active) ? 'Yes' : 'No')
    }
  })])]), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05307ef8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/InputSwitch.vue
// module id = 2176
// module chunks = 1